
import links from '~/data/footer-links.json'

export default

	data: ->
		primaryLinks: links[0]
		secondaryLinks: links[1]
		terciaryLinks: links[2]

